// extracted by mini-css-extract-plugin
module.exports = {"footer":"B_S g_k"};